import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';
import GetGroupResponse from 'owa-service/lib/contract/GetGroupResponse';
import { action } from 'satcheljs/lib/legacy';

export default action('processGetGroupInfoResult')(function processGetGroupInfoResult(
    personaTypeSet: FindRecipientPersonaType[],
    responseMessage: GetGroupResponse
) {
    if (responseMessage.Members) {
        responseMessage.Members.forEach(result => {
            personaTypeSet.push({
                EmailAddress: result.EmailAddress,
                PersonaId: result.PersonaId,
                ADObjectId: result.ADObjectId,
            });
        });
    }
});
